<ng-container *ngIf="media?.data?.attributes?.url">
	<ng-container *ngIf="assetService.isVideo(media?.data?.attributes?.mime) else image">
		<video [src]="media?.data?.attributes?.url"  [controls]="videoControls" [autoplay]="videoAutoplay"></video>
	</ng-container>
	<ng-template #image>
		<img [src]="media?.data?.attributes?.url" [alt]="media?.data?.attributes?.alternativeText || ''">
	</ng-template>
</ng-container>
